<template>
  <div class="schedule">
    <div v-if="editMode">
      <v-layout wrap class="schedule__date-container">
        <v-flex class="schedule__datepicker-box">
          <DatePicker
            required
            label="Escolha a data"
            :changeDate="changeDate"
            :dates="technicalDate"
          />
        </v-flex>
        <v-flex class="schedule__hours-picker-box">
          <HoursPicker
            label="Escolha um horário"
            :options="getHours"
            :changeHour="changeHour"
          />
        </v-flex>
      </v-layout>
      <div class="schedule__costumer-container">
        <div>
          <div>Será acompanhada por <span class="required">*</span></div>
          <v-radio-group v-model="accompanied" :mandatory="false">
            <v-radio class="styled-radio" label="Será acompanhada por mim" value="my"></v-radio>
            <v-radio class="styled-radio" label="Será acompanhada por" value="other"></v-radio>
          </v-radio-group>
        </div>
        <div
          class="schedule__costumer-input-container"
          v-if="accompanied === 'other'"
        >
          <div class="schedule__costumer-input-name">
            <TextField
              required
              auto-grow
              solo
              type="text"
              label="Nome"
              v-model="companion.name"
              :errorMessages="error.name"
            />
          </div>
          <div class="schedule__costumer-input-cpf">
            <div>
              <TextField
                required
                auto-grow
                solo
                type="tel"
                mask="###.###.###-##"
                label="CPF"
                v-model="companion.document"
                :errorMessages="error.document"
              />
            </div>
          </div>
        </div>
        <div
          class="schedule__info-box"
          v-if="accompanied === 'other'">
          A vistoria deverá obrigatoriamente ser acompanhada por respresentante de maior de 18 anos.
        </div>
      </div>
    </div>
    <div v-if="!editMode" class="schedule__info-date">
      {{dateInfo}}
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/fields/DatePicker';
import HoursPicker from '@/components/fields/HoursPicker';
import TextField from '@/components/fields/TextField';
import { validateCPF } from '@/utils/documentValidation';
import { CONFIG } from '@/utils/constants';
import moment from 'moment-timezone';

export default {
  components: {
    DatePicker,
    HoursPicker,
    TextField
  },
  props: {
    onCallback: Function,
    error: Object,
    reasonTicketInfo: Array,
    technicalSchedule: Array,
    technicalDate: Array
  },
  data() {
    return {
      selectedDate: new Date().toISOString().substr(0, 10),
      scheduleSelected: null,
      accompanied: '',
      companion: {
        name: null,
        document: null
      },
      editMode: false,
      dateInfo: undefined
    };
  },
  methods: {
    changeDate(val) {
      this.selectedDate = val;
    },
    changeHour(val) {
      this.selectedHour = val;
      let selected = this.getSchedule(val.value);
      this.scheduleSelected = selected;
      this.setResponse();
    },
    setResponse() {
      let response = {
        schedule: this.scheduleSelected,
        accompanied: this.accompanied,
        companion: this.setCompanion()
      };
      this.onCallback(response);
    },
    setCompanion() {
      if (this.accompanied === 'other') {
        return this.companion;
      } else if (this.accompanied === 'my') {
        return null;
      }
    },
    getSchedule(id) {
      return this.technicalSchedule.find(item => item.id === id);
    },
    mountDateInfo() {
      let ticketDate = this.reasonTicketInfo[0].date;
      this.dateInfo = this.formatLongDateTime(ticketDate);
    },
    loadDate() {
      if (this.reasonTicketInfo && !!this.reasonTicketInfo.length) {
        this.mountDateInfo();
        this.editMode = false;
      } else {
        this.editMode = true;
      }
    }
  },
  created() {
    this.loadDate();
  },
  computed: {
    getHours() {
      return this.technicalDate.filter(item => item.date === this.selectedDate);
    }
  },
  watch: {
    accompanied: function() {
      this.setResponse();
    },
    companion: function() {
      this.setResponse();
    }
  }
};
</script>

<style lang="scss" scoped>
.schedule {
  &__date-container {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  &__datepicker-box {
    display: flex;
    align-content: center;
  }
  &__hours-picker-box {
    display: flex;
  }

  &__costumer-container {
    margin-top: 2rem;
  }

  &__costumer-input-container {
    display: flex;
  }

  &__costumer-input-name {
    border-radius: 4px;
    padding: 3px;
    width: 100%;
  }

  &__costumer-input-cpf {
    border-radius: 4px;
    padding: 3px;
    width: 60%;
  }

  &__info-box {
    background-color: #eeeeee;
    text-align: center;
    padding: 1.7rem;
    border-radius: 4px;
  }
  &__info-date {
    margin: 5rem;
    text-align: center;
    font-weight: bold;
    font-size: 1.5em;
  }
}

.required {
  color: red;
  margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/ticket/technicalAssistance/ScheduleStep.vue